/**
 * Single source of truth for the live webinar promo (banner + email + admin).
 *
 * Edit these constants to change the webinar everywhere. The banner and the
 * layout offsets auto-hide once `endMs` has passed, so nothing needs to be
 * removed by hand after the event.
 */

export const WEBINAR = {
  /** Stable id used to dedupe registrations and group them in admin. */
  id: 'demo-webinar-2026-06-12',
  title: 'StyTrix Demo Webinar',

  // Fri June 12, 2026, 07:00–09:00 UTC (15:00–17:00 GMT+8 / 09:00–11:00 CEST)
  startMs: Date.UTC(2026, 5, 12, 7, 0, 0),
  endMs: Date.UTC(2026, 5, 12, 9, 0, 0),

  meetUrl: 'https://meet.google.com/agm-pqzu-rzb',

  // "Add to Calendar" link (Google Calendar event template) sent in the email.
  addToCalendarUrl:
    'https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=MmRqdnRobzhiOHRiNDQwcjc5dWJkMXZlZTIgY19iNmMzZTEwN2U2MmNhYTQxNmQwZTUxMzI1OTczNjA2MzA5NzA1YmI3OGQ4YmJkZDE5NmRiMTdhODdjOTM1ZmMyQGc&tmsrc=c_b6c3e107e62caa416d0e51325973606309705bb78d8bbdd196db17a87c935fc2%40group.calendar.google.com',

  // Pre-formatted, human-friendly time labels (no runtime tz math needed).
  dateLabel: 'Friday, June 12, 2026',
  timeLabelShort: 'Fri Jun 12 · 3PM GMT+8',
  timeLabelFull: '3:00–5:00 PM (GMT+8) · 9:00–11:00 AM CEST · 07:00–09:00 UTC',
} as const

/** Whether the promo banner / offsets should still be shown. */
export function isWebinarLive(now: number = Date.now()): boolean {
  return now < WEBINAR.endMs
}
